import * as types from '../mutation-types'

const manuscript = {
  state: {
    manuscript: {}
  },

  getters: {
    getManuscript: state => state.manuscript
  },

  actions: {
    updateManuscript({ commit }, info) {
      commit(types.UPDATE_MANUSCRIPT, info)
    }
  },

  mutations: {
    [types.UPDATE_MANUSCRIPT](state, info) {
      state.manuscript = info
    }
  }
}

export default manuscript
